import http from '@/http'

/**
 * Centre API endpoints
 */
export default {
    // Centre API
    async showCentre () {
        try {
            const response = await http.get(`/contact-centre/centre`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async updateCentre (data) {
        try {
            const response = await http.put(`/contact-centre/centre`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
